<template>
    <ul class="list_item_wrap">
        <li class="list_item" style="cursor: pointer" @click="movePage(`/competition/${data.c_uuid}`)" v-for="(data,index) in competitionData" :key="`competition${index}`" v-if="index<8">
            <div class="thumbnail" :style="` background-image: url(${returnImage(data.Poster,278,387, 'png')})`"></div>
            <div class="category_wrap">
                <div class="category_title">{{ returnCategoryName(data.cc_idx) }}</div>
                <div class="wr_subject">{{ data.c_title }}</div>
                <div class="time_text">
<!--                    {{ data.c_context }}-->
                    <competition-date-time :competition-data="data"></competition-date-time>
                </div>
            </div>
        </li>
    </ul>
</template>

<script>
import {mapState} from "vuex";
import util from "@/mixins/util";
import imageOption from "@/mixins/imageOption";
import CompetitionDateTime from "@/components/competition/CompetitionDateTime";
import imageResizeMixins from "@/mixins/imageResizeMixins";

export default {
    name: "CompetitionListSearchLayout",
    mixins: [imageOption,imageResizeMixins],
    components: {CompetitionDateTime},
    inject: [],
    provide() {
        return {}
    },
    props: {
        competitionData: [],
        paginationData: ''
    },
    data() {
        return {
            itemCategorys: []
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.itemCategorys = this.itemCategoryList
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            itemCategoryList: state => state.itemCategory.itemCategoryList,
        })
    },
    methods: {
        movePage(url) {
            this.$router.push(url);
        },
        returnThumbnail(data) {
            if (!util.isEmpty(data.Poster)) {
                return `${data.Poster.org_url}?${this.setImageOptions(278, null, this.returnExtension(data.Poster.org_url))}`;
            }
        },
        returnCategoryName(data) {
            let categoryIndex = this.itemCategorys.findIndex(category => category.node_id === data);
            if (categoryIndex > -1) {
                return this.itemCategorys[categoryIndex].NAME_ENG
            }
        },
        returnImage(image,width=32, height=32, f='png') {
            if (!util.isEmpty(image)) {
                return `${image[0].org_url}?${this.setImageOptions(width, height, this.returnExtension(image[0].org_url))}`
            }
            return ''
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
